import { BitmapFont } from './BitmapFont';
import { Resource } from './Resource';

export class BitmapFontResource extends Resource<BitmapFont> {
  static readonly TypeId: string = 'font';

  constructor(id: string) {
    super(id);
  }

  get typeId(): string {
    return BitmapFontResource.TypeId;
  }
}
